import { defineComponent as _defineComponent } from 'vue'
import { toRefs } from 'vue'
type IProps = {
  couponData: {
    couponType: string
    couponTemplateName: string
    giftRule: Array<{
      giftList: Array<{
        giftName: string
      }>
    }>
    startTime: string
    endTime: string
    validityPeriod: string
  }
}

export default /*#__PURE__*/_defineComponent({
  __name: 'couponRight',
  props: {
    couponData: null
  },
  setup(__props: any) {

const props = __props as {
  couponData: {
    couponType: string
    couponTemplateName: string
    giftRule: Array<{
      giftList: Array<{
        giftName: string
      }>
    }>
    startTime: string
    endTime: string
    validityPeriod: string
  }
};


const { couponData } = toRefs(props)

return { __sfc: true,props, couponData }
}

})